import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReceiptTemplateService } from '../services/receipt-template.service';
import { ReceiptTemplate, TemplateType } from '../models/receipt-template.model';

@Component({
  selector: 'app-print-template-modal',
  templateUrl: './print-template-modal.component.html',
  styleUrls: ['./print-template-modal.component.scss'],
})
export class PrintTemplateModalComponent implements OnInit {

  /**
   * Pass the job type to filter templates shown.
   * e.g. 'JOB_CARD' or 'THIRD_PARTY_DISPATCH'
   */
  @Input() jobType: TemplateType = 'JOB_CARD';

  public templates: ReceiptTemplate[] = [];
  public selectedTemplate: ReceiptTemplate | null = null;
  public loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private templateService: ReceiptTemplateService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.templateService.getTemplates().subscribe(all => {
      this.templates = all.filter(t => t.type === this.jobType);
      // Default to global default if set
      this.selectedTemplate = this.templateService.getGlobalDefault(this.jobType)
        || (this.templates[0] ?? null);
      this.loading = false;
    });
  }

  get globalDefault(): ReceiptTemplate | undefined {
    return this.templates.find(t => t.isGlobalDefault);
  }

  selectTemplate(template: ReceiptTemplate): void {
    this.selectedTemplate = template;
  }

  print(): void {
    this.activeModal.close(this.selectedTemplate);
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}
